export const toBase64 = (str: string): string =>
	typeof window === `undefined` ? Buffer.from(str).toString(`base64`) : window.btoa(str)
